module.exports = __webpack_public_path__ + "components/flag/static/square/gn-f346cf022761c95511f98706c72b6a6d.svg";